import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

import {
    ActiveShipmentsContext,
    CollaboratorsContext,
    HomeContext,
    ManagementContext,
    MemberContext,
    OrganizationContext,
    TeamContext,
} from 'contexts';

import {
    MultiSelect,
    Button,
} from 'components';
import {
    MEMBER,
    // TEAM
} from 'actions';
import avatar from 'assets/images/avatar.png';
import { ALL, MYTASK, OTHERS, PERMISSIONS_LIST, SHIPMENT_ADMIN, TEAM } from 'actions/constants';
import { useForm } from 'react-hook-form';
import { 
    useLocation
    // , useParams 
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Input } from 'components/common';
import { getErrorMessage } from 'utils';

export const AddCollaborator = ({
    goBack,
}) => {
    const { t } = useTranslation();
    // const [selectedValues, setSelectedValues] = useState([]);
    const [adminGroups, setAdminGroups] = useState([0]);

    const [selectedAdminGroups, setSelectedAdminGroups] = useState([{
        roleType: "",
        orgId: "",
        partners: []
    }])
    const [groups, setGroups] = useState([0]);
    const [selectedGroups, setSelectedGroups] = useState([{
        roleType: "",
        orgId: "",
        partners: []
    }]);
    const [currentOrg, setCurrentOrg] = useState(null);
    const [partners, setPartners] = useState([]);
    const [organizations, setOrganzations] = useState([]);
    const [allPartners, setAllPartners] = useState([]);
    const { isTemplate, permission } = useContext(HomeContext);
    const { doCreateCollaborators, doGetCollaborators } = useContext(CollaboratorsContext);
    // const { doAddCollabratorsTemplate, doGetTemplatesDetails, templatesDetails } = useContext(TemplateContext);
    // const { doGetShipmentInfo } = useContext(ShipmentInfoContext);
   
    const { doGetActiveShipmentsDetails } = useContext(ActiveShipmentsContext);
    const { doGetTaskManagements } = useContext(ManagementContext);
    const { allOrganizations, doGetAllOrganizations } = useContext(OrganizationContext);
    const { doGetOrgMembers } = useContext(MemberContext); 
    const { doGetOrgTeams } = useContext(TeamContext); 
    const {
        setNotificationMessage,
        currentTabManagement
    } = useContext(HomeContext);
    const { register, errors, handleSubmit } = useForm();
    const location = useLocation();
    const pathnameArr = location.pathname.split('/');
    const shipmentId = pathnameArr[pathnameArr.length - 1];
    const MEMBER_U = MEMBER.toUpperCase();
    const TEAM_U = TEAM.toUpperCase();
    // const { templateId } = useParams();
    // const newArray = selectedValues.map(item => {
    //     return item.partners;
    // })
    const inviteByEmail = 'Invite by email';
    /*eslint-disable */

    useEffect(() => {
        doGetAllOrganizations({
            page: 0,
            limit: 999,
            tab: OTHERS
        }, (data) => {
            setOrganzations(data)

        });
    }, [])
    useEffect(() => {
        
        if (currentOrg) {
            doGetOrgMembers({
                orgId: currentOrg,
                page: 0,
                limit: 0,
                isSearching: true
            }, (memberData) => {
                doGetOrgTeams({
                    orgId: currentOrg,
                    isSearching: true
                }, (teamData) => {
                    let memberList = memberData.items.map(mem => {
                        return {
                            _id: mem._id,
                            name: mem.name,
                            email: mem.email,
                            avatar: mem.avatar || "",
                            type: MEMBER_U
                        }
                    })
                    let teamList =  teamData.items.map(team => {
                        return {
                            _id: team._id,
                            name: team.name,
                            type: TEAM_U,
                            email: "",
                            avatar: ""
                        }
                    })
                    let newPartners = memberList.concat(teamList)
                    // setPartners(newPartners)
                    setAllPartners(newPartners)
                });
            });
           
        }
        
    }, [currentOrg])
    /*eslint-enable */

    const handleAddGroup = () => {
        setGroups(old => [...old, old.length]);
        setSelectedGroups(old => [...old, {
            orgId: "",
            partners: []
        }]);
    }

    const handleAddGroupAdmin = () => {
        setAdminGroups(old => [...old, old.length]);
        setSelectedAdminGroups(old => [...old, {
            orgId: "", 
            partners: []
        }]);
    }

    const handleChooseOrg = (value, groupNumber, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            newSelectedGroup[groupNumber].orgId = value.key;
            setSelectedAdminGroups(newSelectedGroup);
            
        } else {
            let newSelectedGroup = [...selectedGroups];
            newSelectedGroup[groupNumber].orgId = value.key;
            setSelectedGroups(newSelectedGroup);
        }
        
        setCurrentOrg(value.key);
    }

    const handleChoosePartners = (value, groupNumber, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            let newPartner = {
                id: value[0].id,
                name: value[0].email,
                type: value[0].type,
                avatar: value[0].icon,
                orgId: newSelectedGroup[groupNumber].orgId,
                role: newSelectedGroup[groupNumber].roleType = SHIPMENT_ADMIN
            }
            newSelectedGroup[groupNumber].partners.push(newPartner);
            
            setSelectedAdminGroups(newSelectedGroup)
        } else {
            let newSelectedGroup = [...selectedGroups];
            let newPartner = {
                id: value[0].id,
                name: value[0].email,
                type: value[0].type,
                avatar: value[0].icon,
                orgId: newSelectedGroup[groupNumber].orgId,
                role: ""
            }
            newSelectedGroup[groupNumber].partners.push(newPartner);

            
            setSelectedGroups(newSelectedGroup)
        }

        setPartners([]);
       
    }

    const handleChangeRoleName = (value, groupNumber, memberId) => {
        let newSelectedGroup = [...selectedGroups];
        newSelectedGroup[groupNumber].partners[memberId].role = value;
        setSelectedGroups(newSelectedGroup)
    }
    const handleRemovePartner = (groupNumber, memberId, type) => {
        if (type === SHIPMENT_ADMIN) {
            let newSelectedGroup = [...selectedAdminGroups];
            let filteredMembers = newSelectedGroup[groupNumber].partners.filter(member => member.id !== memberId); 
            newSelectedGroup[groupNumber].partners = filteredMembers;
            setSelectedAdminGroups(newSelectedGroup)
        } else {
            let newSelectedGroup = [...selectedGroups];
            let filteredMembers = newSelectedGroup[groupNumber].partners.filter(member => member.id !== memberId); 
            newSelectedGroup[groupNumber].partners = filteredMembers;
            setSelectedGroups(newSelectedGroup)
        }
       
    }

    const onSearchOrganization = (value) => {
        if (organizations) {
            const filterOrgs = allOrganizations.filter(org => org.name.toLowerCase().includes(value.toLowerCase()));
            setOrganzations(filterOrgs)
        }
    }

    const handleAddCollaborator = (data) => {
        const adminRoles = Array.prototype.concat.apply([], selectedAdminGroups.map(mem => mem.partners));
        const customRoles = Array.prototype.concat.apply([], selectedGroups.map(mem => mem.partners));
        const payload = {
            rolesInShipment: adminRoles.concat(customRoles).map(role => { 
                return {
                    roleType: role.role,
                    partners: [{
                        id: role.id,
                        type: role.type,
                        orgId: role.orgId
                    }]
                }
            })
        }

        // const payloadTemplate = selectedValues.filter(e => e.partners.length > 0);

        if (isTemplate) {
            // doAddCollabratorsTemplate(templateId, payloadTemplate, () => {
            //     setNotificationMessage(`
            //     <p> ${t("home.add-new-request.add_collabrators")}</p>
            //     `);
            //     doGetTemplatesDetails(templatesDetails && templatesDetails.id);
            //     // goBack();
            // })
        } else {
            doCreateCollaborators(shipmentId, payload, () => {
                setNotificationMessage(`
                <p> ${t("home.add-new-request.add_collabrators")}</p>
                `);
                // doGetShipmentInfo(shipmentId);
                doGetActiveShipmentsDetails(shipmentId);
                doGetCollaborators(shipmentId, {
                });
                doGetTaskManagements(shipmentId, {
                    page: 0,
                    tab: currentTabManagement === ALL ? ALL : MYTASK
                });
                goBack();

            })
        }

    }

    const checkPermission = (action) => {
        return permission?.shipmentFunctions.includes(action);
    }

    const getMembersTeams = (value) => {
        if (value.length > 0) {
            const filteredPartners = allPartners.filter(partner => (partner?.name.toLowerCase().includes(value.toLowerCase()) || partner?.email.toLowerCase().includes(value.toLowerCase())));
            setPartners(filteredPartners)
        } else {
            setPartners([])
        }
        
    }

    return (
        <div
            className="tr__add-collaborator"
        >
            <div className="tr__add-collaborator--title d-flex align-items-center col-12">
                <p className="tr__link tag mrx2" onClick={goBack}>
                    <i className="icon-chevron-left" />
                    <span>{t("home.addcollaborator.back")}</span>
                </p>
                <h2 className="h2 f-medium">{t("home.addcollaborator.title")}</h2>
            </div>
            <form onSubmit={handleSubmit(handleAddCollaborator)} >
            <div className="col-12">
                    {(checkPermission(PERMISSIONS_LIST.SHIPMENT_ADD_SHIPMENT_ADMIN) || isTemplate) && (
                        <div className="col-12 px2 d-flex flex-wrap">
                        {adminGroups.map((group, groupIndex) => (
                            <div className="col-4" key={groupIndex}>
                                <Dropdown
                                    className="select big-label px4"
                                    icon="icon-chevron-down"
                                    iconPosition="right"
                                    mode="input"
                                    name="organization"
                                    label={t("home.active-shipment.choose-your-organization")}
                                    options={organizations && organizations.length > 0 ? organizations.map(org => {
                                        return {
                                            key: org._id,
                                            value: org.name
                                        }
                                    }) : []}
                                    placeholder={t("home.active-shipment.select-organization")}
                                    dropdownPosition="center"
                                    onChange={value => handleChooseOrg(value, groupIndex, SHIPMENT_ADMIN)}
                                    onInputChange={onSearchOrganization}
                                    // searchLoading={orgLoading}
                                    // refs={register({ required: !markAsShipmentTemplate })}
                                    // refs={register({ required: true })}
                                // error={!!errors.organization}
                                // errorMessage={getErrorMessage(errors.organization, "Organization")}
                                />
                                <MultiSelect
                                    className={`${!selectedAdminGroups[groupIndex]?.orgId ? 'disabled' : ''} mbx4`}
                                    value={selectedAdminGroups[groupIndex].partners}
                                    name="consignee"
                                    label={t("home.addcollaborator.shipment_admin.label")}
                                    // addButton={true}
                                    options={partners ? partners.map(item => {
                                        return {
                                            email: item.email,
                                            id: item._id || new Date().getTime().toString(),
                                            icon: item._id ? (item.type === MEMBER_U ? (item.avatar ?  item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                                            title: item._id ? item.name : item.email,
                                            description: item._id ? (item.type === MEMBER_U ? item.email : item.name) : inviteByEmail,
                                            type: item.type
                                        }
                                    }) : []}
                                    // addButtonLabel="Add"
                                    onInputChange={value => getMembersTeams(value)}
                                    // searchLoading={memberLoading[0] || teamLoading[0]}
                                    labelIcon='icon-admin'
                                    placeholder={t("home.addcollaborator.placeholder")}
                                    // register={register()}
                                    onChange={items => {
                                        handleChoosePartners(items, groupIndex, SHIPMENT_ADMIN);
                                    }}
                                    mode="select"
                                    renderList={members => (
                                        <div className="tr__partners d-flex flex-wrap mtx1">
                                            {members.map((member, memberIndex) => (
                                               <div className="tr__partners--item col-12 d-flex justify-content-between align-items-center mbx2" key={memberIndex}>
                                                   <div className="d-flex align-items-center">
                                                       <i className="icon-times mrx3" onClick={() => handleRemovePartner(groupIndex, member.id, SHIPMENT_ADMIN)}></i>
                                                       {member?.type === TEAM.toUpperCase() ? <span className="icon-users mrx2"></span> : <img src={member?.avatar} alt={"avatar"} />}
                                                       <h3 className="f-medium h3">{member.name}</h3>
                                                   </div>
                                               </div>
                                            ))}
                                        </div>
                                    )}
                                />
                            </div>
                        ))}
        
                        <div className="col-4">
                            <p className="tr__link mbx2" onClick={handleAddGroupAdmin}>
                                <i className="icon-plus mrx1" />
                                <span>{t('Add more shipment admin')}</span>
                            </p>
                        </div>
                    </div>
                    )}
            </div>
            <div className="col-12 px2 d-flex flex-wrap">
                {groups.map((group, groupIndex) => (
                    <div className="col-4" key={groupIndex}>
                        <Dropdown
                            className="select big-label px4"
                            icon="icon-chevron-down"
                            iconPosition="right"
                            mode="input"
                            name="organization"
                            label={t("home.active-shipment.choose-your-organization")}
                            options={organizations && organizations.length > 0 ? organizations.map(org => {
                                return {
                                    key: org._id,
                                    value: org.name
                                }
                            }) : []}
                            placeholder={t("home.active-shipment.select-organization")}
                            dropdownPosition="center"
                            onChange={value => handleChooseOrg(value, groupIndex, "CUSTOM")}
                            onInputChange={onSearchOrganization}
                            // searchLoading={orgLoading}
                            // refs={register({ required: !markAsShipmentTemplate })}
                            // refs={register({ required: true })}
                        // error={!!errors.organization}
                        // errorMessage={getErrorMessage(errors.organization, "Organization")}
                        />
                        <MultiSelect
                            className={`${!selectedGroups[groupIndex]?.orgId ? 'disabled' : ''} mbx4`}
                            value={selectedGroups[groupIndex].partners}
                            name="custom"
                            label={t("home.addcollaborator.custom.label")}
                            // addButton={true}
                            options={partners ? partners.map(item => {
                                return {
                                    email: item.email,
                                    id: item._id || new Date().getTime().toString(),
                                    icon: item._id ? (item.type === MEMBER_U ? (item.avatar ? item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                                    title: item._id ? item.name : item.email,
                                    description: item._id ? (item.type === MEMBER_U ? item.email : item.name) : inviteByEmail,
                                    type: item.type
                                }
                            }) : []}
                            // addButtonLabel="Add"
                            onInputChange={value => getMembersTeams(value)}
                            // searchLoading={memberLoading[0] || teamLoading[0]}
                            labelIcon='icon-users'
                            placeholder={t("home.addcollaborator.placeholder")}
                            // register={register()}
                            onChange={items => {
                                handleChoosePartners(items, groupIndex);
                            }}
                            mode="select"
                            renderList={members => (
                                <div className="tr__partners d-flex flex-wrap mtx1">
                                    {members.map((member, memberIndex) => (
                                       <div className="tr__partners--item col-12 d-flex justify-content-between align-items-center mbx2" key={memberIndex}>
                                           <div className="d-flex align-items-center">
                                               <i className="icon-times mrx3" onClick={() => handleRemovePartner(groupIndex, member.id, "CUSTOM")}></i>

                                               {member?.type === TEAM.toUpperCase() ? <span className="icon-users mrx2"></span> : <img src={member?.avatar} alt={"avatar"} />}
                                               
                                               <h3 className="f-medium h3">{member.name}</h3>
                                           </div>
                                           <Input 
                                                placeholder="Please enter the custom role..."
                                                onChange={(e) => handleChangeRoleName(e.target.value, groupIndex, memberIndex)}
                                                maxLength={50}
                                                name={`customRole-${groupIndex}-partner-${memberIndex}`}
                                                refs={register({ required: true })}
                                                error={!!errors[`customRole-${groupIndex}-partner-${memberIndex}`]}
                                                errorMessage={getErrorMessage(errors[`customRole-${groupIndex}-partner-${memberIndex}`], "custom role")}
                                                // value={selectedGroups[groupIndex].partners[memberIndex].role}
                                            />
                                       </div>
                                    ))}
                                </div>
                            )}
                        />
                    </div>
                ))}

                <div className="col-4">
                    <p className="tr__link mbx2" onClick={handleAddGroup}>
                        <i className="icon-plus mrx1" />
                        <span>{t('Add more custom role')}</span>
                    </p>
                </div>


            </div>

            <div className="tr__add-collaborator--footer d-flex align-items-center justify-content-between">
                <p className="f-medium">{t("home.addcollaborator.message-footer")}</p>
                <Button
                    isSubmitBtn={true}

                    // disabled={newArray.some(e => e.length > 0) ? false : true}
                >
                    {t("home.addcollaborator.add")}
                </Button>
            </div>
            </form>
            
        </div>
    )
};

AddCollaborator.propTypes = {
    goBack: PropTypes.func
};
